import { BaseItem } from './common';
import * as Order from './order';

export interface InputOrder {
  kind: Order.Kind;
  name: string;
  [key: string]: any; // for any other fields
}

export enum Source {
  Predict = 'PREDICT',
  Fingerprint = 'FINGERPRINT',
  CarryForward = 'CARRY_FORWARD',
  QM = 'QM',
  Analyst = 'ANALYST',
  External = 'EXTERNAL',
  EncounterPatientData = 'ENCOUNTER_PATIENT_DATA',
  Structure = 'STRUCTURE',
}

export enum Laterality {
  Left = 'LEFT',
  Right = 'RIGHT',
  Bilateral = 'BILATERAL',
}

export enum Status {
  Pending = 'PENDING',
  SubmittingToEhr = 'SUBMITTING_TO_EHR',
  SubmittedToEhr = 'SUBMITTED_TO_EHR',
  NeedsManualSubmit = 'NEEDS_MANUAL_SUBMIT',
}

export interface EncounterProblemBase {
  encounterId: string;
  problem: string;
  laterality?: Laterality;
  status: Status;
}

export interface CreateValues extends EncounterProblemBase {
  icd10s: string[];
  orders: InputOrder[];
}

export interface EncounterProblem extends CreateValues, BaseItem {}
